import { app } from '@/main'

export const username = (min = 5, max = 20) => {
  return {
    rules: [
      {
        validator: (rule, value, cb) => {
          let check = !/^[A-Za-z0-9]+$/.test(value)
          if (!value)
            return cb(
              app.$t('i18n_please_input', {
                field: app.$t('i18n_account')
              })
            )
          if (value.length < min || value.length > max || check)
            return cb(app.$t('i18n_account_verification'))
          return cb()
        }
      }
    ]
  }
}

export const password = (min = 8, max = 20) => {
  return {
    rules: [
      {
        validator: (rule, value, cb) => {
          let check = !/^[A-Za-z0-9\-~!@#$%^&*()_+{}|:"<>?[\]\\;',./\s]+$/.test(
            value
          )
          if (!value)
            return cb(
              app.$t('i18n_please_input', {
                field: app.$t('i18n_password')
              })
            )
          if (value.length < min || value.length > max || check)
            return cb(app.$t('i18n_password_verification'))
          return cb()
        }
      }
    ]
  }
}

export const newPassword = (min = 8, max = 20) => {
  return {
    rules: [
      {
        validator: (rule, value, cb) => {
          let check = !/^[A-Za-z0-9\-~!@#$%^&*()_+{}|:"<>?[\]\\;',./\s]+$/.test(
            value
          )
          if (!value)
            return cb(
              app.$t('i18n_rule_required_fill', {
                field: app.$t('i18n_new_password')
              })
            )
          if (value.length < min || value.length > max || check)
            return cb(
              app.$t('i18n_rule_case_alphanumeric_symbol_interval', {
                target: app.$t('i18n_password'),
                min,
                max
              })
            )
          return cb()
        }
      }
    ]
  }
}

export const name = () => {
  return {
    validateFirst: true,
    rules: [
      {
        required: true,
        message: function() {
          return app.$t('i18n_please_input', {
            field: app.$t('i18n_name')
          })
        }
      },
      {
        pattern: /^[\u4e00-\u9fa5A-Za-z0-9~!@#$%^&*()-_+{}|:"<>?[\]\\;',./\s]+$/,
        message: function() {
          return app.$t('i18n_reset_otp_error_when_input_name')
        }
      }
    ]
  }
}
